import React, { useState, useEffect } from 'react';
import EnablementCards from '../../Components/Sidebars/Entry/EnablementCards';
import ActiveCollaborators from '../../Components/App/ActiveCollaborators';
import Timer from './Timer';
import { connect } from 'react-redux';

import {
  Button
} from '@salesforce/design-system-react';

const Banner = (props) => {
  return (
    <div>
      <div className="slds-grid" style={{ backgroundColor: "#fff", paddingLeft: 'max(240px, 18%)', minWidth: '1200px', position: 'fixed', top: '0', right: '0', left: '0', zIndex: '9', boxShadow: '1px 1px 2px 0px #ccc'}}>
        <div className="slds-size_1-of-12 slds-p-vertical_x-small">
            <Button
              iconCategory="utility"
              iconName="chevronleft"
              iconSize="large"
              variant="brand"
              onClick={props.previous}
              style={{ borderRadius: '50%', backgroundColor: '#032D60', border: 'none'}}
              className="slds-p-around_xx-small slds-m-right_xx-small"
            />
            {props.stage !== "Product Overlays" ? (
              <Button
                iconCategory="utility"
                iconName="chevronright"
                iconSize="large"
                variant="brand"
                onClick={props.next}
                style={{ borderRadius: '50%', backgroundColor: '#032D60', border: 'none'}}
                className="slds-p-around_xx-small"
              />
            ) : null}
        </div>
        <div className="slds-size_3-of-12 slds-p-vertical_x-small" style={{ color: '#032D60', fontSize: '1.4rem', fontWeight: '500' }}>
          {(props && props.journeyName != null && props.journeyName != undefined && props.journeyName.length > 25) 
          ? props.journeyName.substring(0,25) + "..." : props.journeyName}
        </div>
        <div className="slds-size_5-of-12" />
        <div className="slds-size_3-of-12">
          <ActiveCollaborators />
        </div>
      </div>
      <div 
        style={{ 
          marginTop: '51px', 
          marginLeft: '15%', 
          backgroundImage: "url("+ props.backgroundImage + ")",
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat'
        }}
        className="slds-grid"
      >
        <div className="slds-size_2-of-12" />
        <h1 className="slds-size_7-of-12 slds-align_absolute-center" style={{ fontSize: '2.2rem', color: '#fff'}}>{props.stage === "Product Overlays" ? "Salesforce Products" : "Define " + props.stage}</h1>
        <div className="slds-size_3-of-12 slds-p-vertical_medium slds-p-right_medium">
          <Timer />
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  journeyName: state.app.journeyName,
});

export default connect(mapStateToProps, null)(Banner);
